module.exports = __webpack_public_path__ + "img/Screen-Shot-2017-04-17-at-3.37.02-PM.469d4362.jpg";